import React, { useState, useEffect } from 'react';

export default function ThemeToggle() {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem('pilotleague-theme') || 'dark';
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('pilotleague-theme', theme);
  }, [theme]);

  return (
    <div className="theme-toggle">
      <button
        className={`theme-btn ${theme === 'dark' ? 'theme-btn--active' : ''}`}
        onClick={() => setTheme('dark')}
        aria-label="Mode sombre"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 3a9 9 0 1 0 9 9c0-.46-.04-.92-.1-1.36a5.389 5.389 0 0 1-4.4 2.26 5.403 5.403 0 0 1-3.14-9.8c-.44-.06-.9-.1-1.36-.1z"/>
        </svg>
        Dark
      </button>
      <button
        className={`theme-btn ${theme === 'light' ? 'theme-btn--active' : ''}`}
        onClick={() => setTheme('light')}
        aria-label="Mode clair"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zM2 13h2c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1zm18 0h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1z"/>
        </svg>
        Light
      </button>
    </div>
  );
}
